import { useCallback, useRef } from "react";

export const useDebounce = () => {
  const timer = useRef<ReturnType<typeof setTimeout>>();
  const clearDebounce = useCallback(() => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = undefined;
  }, [timer]);

  const debounce = useCallback(
    (f: () => void, delayMs: number = 200) => {
      clearDebounce();
      timer.current = setTimeout(f, delayMs);
    },
    [clearDebounce],
  );

  return { debounce, clearDebounce };
};
